<template>
  <v-dialog
    v-model="dialog"
    max-width="1200px"
    @click:outside="closeDialog"
  >
    <v-card>
      <v-form>
        <v-card-title>
          <span class="headline">Generar Pagos Múltiples</span>
        </v-card-title>

        <v-card-text style="min-height: 600px">
          <v-stepper v-model="currentStep" class="elevation-0">
            <v-stepper-header style="background: #607d8b; color: white">
              <v-stepper-step :complete="currentStep > 1" step="1" editable>
                <span class="text-white">Forma de Pago</span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="currentStep > 2" step="2" editable>
                <span class="text-white">Pagos</span>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <!-- STEP 1: Forma de Pago -->
              <v-stepper-content step="1">
                <div class="row justify-content-center mt-4">
                  <div class="col-md-10">
                    <div class="mb-4 d-flex align-center">
                      <v-chip color="primary" outlined>
                        <v-icon left small>mdi-file-document-outline</v-icon>
                        {{ paymentOrdersList.length }} solicitud(es) de pago
                      </v-chip>
                      <v-chip class="ml-2" color="red" outlined>
                        <v-icon left small>mdi-cash-multiple</v-icon>
                        Total pagado: {{ formatPrice(totalPagar) }}
                      </v-chip>
                    </div>
                    <p class="mb-4 mt-4 text-body-2 text-caption">
                      Para continuar, seleccione una forma de pago y una cuenta de tesoreria. Que se aplicara a todas las solicitudes de pago. Luego, en el siguiente paso, se procesaran cada una de las solicitudes de pago y se generara un pago por cada una de ellas con la forma de pago y cuenta de tesoreria seleccionada.
                    </p>
                     <div class="row justify-content-center mt-4">
                      <div class="col-md-4 mt-4">
                        <v-text-field
                          v-model="massivePaymentItem.cbte_fch"
                          type="date"
                          label="Fecha de pago"
                          dense
                          hide-details="auto"
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                      <div class="col-md-4 mt-4">
                        <v-combobox
                          v-model="massivePaymentItem.payment_method"
                          :items="paymentMethods"
                          item-text="name"
                          item-value="id"
                          label="Forma de pago"
                          clearable
                          dense
                          hide-details="auto"
                          @change="handlePaymentMethodChange"
                        ></v-combobox>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-4">
                      <div class="col-md-4 mt-4">
                        <v-combobox
                          v-model="massivePaymentItem.money_account"
                          :items="moneyAccounts"
                          item-text="name"
                          item-value="id"
                          label="Cuenta"
                          clearable
                          dense
                          hide-details="auto"
                          :disabled="massivePaymentItem.payment_method == null"
                        ></v-combobox>
                      </div>
                    </div>
                     <div class="row justify-content-center mt-4">
                      <div class="col-md-4">
                        <v-checkbox
                          v-model="massivePaymentItem.send_payment_email"
                          label="Enviar comprobante de pago por email"
                          hide-details
                          class="mt-0 pt-0"
                        ></v-checkbox>
                      </div>
                    </div>
                   
                  </div>
                </div>
              </v-stepper-content>

              <!-- STEP 2: Pagos -->
              <v-stepper-content step="2">
                <div class="row justify-content-center">
                  <div class="col-md-10">
                    <div class="mb-4 d-flex align-center">
                      <v-chip
                        color="primary"
                        outlined
                      >
                        <v-icon left small>mdi-file-document-outline</v-icon>
                        {{ paymentOrdersList.length }} solicitud(es) de pago
                      </v-chip>
                      <v-chip
                        class="ml-2"
                        color="red"
                        outlined
                      >
                        <v-icon left small>mdi-cash-multiple</v-icon>
                        Total pagado: {{ formatPrice(totalPagar) }}
                      </v-chip>
                    </div>

                    <div style="border: solid 1px #999">
                      <v-data-table
                        :headers="headersPaymentOrders"
                        :items="paymentOrdersList"
                        item-key="id"
                        hide-default-footer
                        :items-per-page="-1"
                        class="elevation-1"
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td>{{ item.nro_orden }}</td>
                            <td>{{ item.supplier_name }}</td>
                            <td class="text-right grey--text text--darken-1"> {{ formatPrice(item.amount) }}</td>
                            <td class="text-right grey--text text--darken-1">{{ formatPrice(getTotalRetenciones(item)) }}</td>
                            <td class="text-right font-weight-bold">{{ formatPrice(item.imp_total) }}</td>
                            <td style="min-width: 200px">
                              <span v-if="item.loading">Procesando...</span>
                              <span v-else-if="item.status === 0">Pendiente de procesado</span>
                              <span v-else-if="item.status === 1 && item.status_create" class="text-green">Pagado</span>
                              <span v-else-if="item.status === 1 && !item.status_create" class="text-red">{{ item.msg }}</span>
                            </td>
                          </tr>
                        </template>
                      </v-data-table>
                    </div>

                    <div class="pt-0 mt-3">
                      <p style="color: #1976d2; float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Pendientes de procesar: {{ getPendienteProcesar() }}</p>
                      <p class="text-green" style="float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Pagos procesados válidos: {{ getProcesadosValidos() }}</p>
                      <p style="color: red; margin-bottom: 0px; font-size: 16px; margin-bottom: 5px">Pagos procesados inválidos: {{ getProcesadosNoValidos() }}</p>
                    </div>

                    <div class="row mt-1" v-if="loading_create">
                      <div class="col-md-12">
                        <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important">
                          <strong>{{ Math.ceil(percent) }}%</strong>
                        </v-progress-linear>
                      </div>
                    </div>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-card-actions class="dialog-footer px-4">
          <template v-if="currentStep === 1">
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>
            <v-btn
              color="green"
              text
              @click="nextStep"
              :disabled="!canGoToStepTwo"
            >
              Siguiente
            </v-btn>
          </template>

          <template v-else>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="previousStep">Anterior</v-btn>
            <v-btn color="error" text @click="closeDialog">Cerrar</v-btn>

            <v-btn
              color="green"
              text
              @click="generatePayments"
              :disabled="paymentOrdersList.length === 0"
              :loading="loading_create"
            >
              Generar Pagos
            </v-btn>
          </template>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { paymentSpentService } from "@/libs/ws/paymentSpentService";
import { paymentOrderService } from "@/libs/ws/paymentOrderService";
import { generalService } from "@/libs/ws/generalService";
import sections from "@/constants/sections";
import paymentMethod from "@/constants/paymentMethod";

export default {
  name: "DialogGenerarPagoMasivo",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    paymentOrderIds: {
      type: Array,
      default: () => []
    },
    paymentOrders: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentStep: 1,
      massivePaymentItem: {
        id: 0,
        supplier: null,
        spents: [],
        payment_method: null,
        money_account: null,
        dolar_cotiz: null,
        fch_payment_efective: null,
        tributes: [],
        spent_payment_methods: [],
        cbte_fch: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        receiver: null,
        observation: null,
        send_payment_email: true,
      },
      paymentOrdersList: [],
      headersPaymentOrders: [
        { text: "Nº Solicitud", value: "nro_orden", sortable: true, align: "left" },
        { text: "Proveedor", value: "supplier.name", sortable: true, align: "left" },
        { text: "Total pagado", value: "", sortable: false, align: "right" },
        { text: "Total retenciones", value: "", sortable: false, align: "right" },
        { text: "Total recibo de pago", value: "imp_total", sortable: true, align: "right" },
        { text: "Respuesta", value: "actions", sortable: false, align: "right" },
      ],
      paymentMethods: [],
      moneyAccounts: [],
      loading_create: false,
      envios_creados: 0,
      envios_no_validos: 0,
    };
  },
  computed: {
    canGoToStepTwo() {
      return (
        this.paymentOrdersList.length > 0 &&
        this.massivePaymentItem.payment_method != null &&
        this.massivePaymentItem.money_account != null &&
        this.massivePaymentItem.cbte_fch != null
      );
    },
    totalPagar() {
      return this.paymentOrdersList.reduce(
        (acc, item) => acc + parseFloat(item.imp_total || 0),
        0
      );
    },
    percent: {
      get() {
        if (this.paymentOrdersList.length === 0) return 0;
        return (
          (this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100
        ) / this.paymentOrdersList.length;
      },
      set(value) {
        return value;
      },
    },
  },
  created: function () {
    window.addEventListener("keydown", (e) => {
      if (e.key == "Escape") {
        this.closeDialog();
      }
    });
  },
  watch: {
    dialog(newVal) {
      if (newVal) {
        this.resetDialog();
        this.loadPaymentOrders();
        this.loadPaymentMethods();
        this.loadMoneyAccounts();
      }
    },
  },
  methods: {
    formatPrice(value) {
      return formatUtils.formatPrice(value);
    },

    getPendienteProcesar() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 0).length;
    },

    getProcesadosValidos() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 1 && element.status_create).length;
    },

    getProcesadosNoValidos() {
      if (this.paymentOrdersList.length === 0) return 0;
      return this.paymentOrdersList.filter((element) => element.status === 1 && !element.status_create).length;
    },

    // getTotalImputar(item) {
    //   if (!item.spents || !Array.isArray(item.spents)) return 0;
    //   const spentsTotal = item.spents.reduce((total, spent) => total + parseFloat(spent.imp_total || 0), 0);
    //   const pagoACuenta = parseFloat(item.pago_a_cuenta || 0);
    //   return spentsTotal + pagoACuenta;
    // },

    getTotalRetenciones(item) {

        // if(!item.tributes || !Array.isArray(item.tributes)) return 0; 
        return parseFloat(item.imp_total) - parseFloat(item.amount);
    //   if (!item.tributes || !Array.isArray(item.tributes)) return 0;
    //   return item.tributes.reduce((total, tribute) => total + parseFloat(tribute.amount || 0), 0);
    },

    resetDialog() {
      this.currentStep = 1;
      this.paymentOrdersList = [];
      this.massivePaymentItem = {
        id: 0,
        supplier: null,
        spents: [],
        payment_method: null,
        money_account: null,
        dolar_cotiz: null,
        fch_payment_efective: null,
        tributes: [],
        spent_payment_methods: [],
        cbte_fch: new Date(
          new Date().toLocaleDateString("en-US", {
            timeZone: "America/Buenos_Aires",
          })
        )
          .toISOString()
          .slice(0, 10),
        receiver: null,
        observation: null,
        send_payment_email: true,
      };
      this.loading_create = false;
      this.envios_creados = 0;
      this.envios_no_validos = 0;
    },

    handlePaymentMethodChange() {
      this.massivePaymentItem.money_account = null;
    },

    closeDialog() {
      this.$emit("closeDialog");
    },

    nextStep() {
      if (this.currentStep < 2) {
        this.currentStep++;
      }
    },

    previousStep() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },

    loadPaymentOrders() {
      this.paymentOrdersList = this.paymentOrders.map(order => ({
        ...order,
        status: 0,
        status_create: false,
        loading: false,
        msg: "",
      }));

      if (this.paymentOrdersList.length > 0) {
        const firstOrder = this.paymentOrdersList[0];
        const firstPaymentMethodId = firstOrder.payment_method ? firstOrder.payment_method.id : null;
        const firstMoneyAccountId = firstOrder.money_account ? firstOrder.money_account.id : null;

        const hasSamePaymentConfig = this.paymentOrdersList.every((order) => {
          const paymentMethodId = order.payment_method ? order.payment_method.id : null;
          const moneyAccountId = order.money_account ? order.money_account.id : null;
          return paymentMethodId === firstPaymentMethodId && moneyAccountId === firstMoneyAccountId;
        });

        if (hasSamePaymentConfig && firstOrder.payment_method && firstOrder.money_account) {
          this.massivePaymentItem.payment_method = JSON.parse(JSON.stringify(firstOrder.payment_method));
          this.massivePaymentItem.money_account = JSON.parse(JSON.stringify(firstOrder.money_account));
        }
      }

      const uniqueReceivers = this.paymentOrders
        .map(order => order.receiver)
        .filter(receiver => receiver && receiver.id);
      const sameReceiver =
        uniqueReceivers.length > 0 &&
        uniqueReceivers.every(receiver => receiver.id === uniqueReceivers[0].id);
      this.massivePaymentItem.receiver = sameReceiver ? uniqueReceivers[0] : null;
      this.loadMoneyAccounts();

      this.massivePaymentItem.spents = [
        {
          id: 0,
          imp_total: this.totalPagar,
        },
      ];
    },

    loadPaymentMethods() {
      generalService.setSection(sections.SECTION_PAYMENT_METHODS);
      generalService
        .filter()
        .then((response) => {
          const items = response.result || [];
          this.paymentMethods = items.filter((item) => item.id !== paymentMethod.cheque);
        })
        .catch((e) => {
          console.log("payment_methods.filter error", e);
          this.paymentMethods = [];
        });
    },

    loadMoneyAccounts() {
      const params = {};
      if (this.massivePaymentItem.receiver && this.massivePaymentItem.receiver.id > 0) {
        params.emitter = { id: this.massivePaymentItem.receiver.id };
      }

      generalService.setSection(sections.SECTION_MONEY_ACCOUNTS);
      generalService
        .filter(params)
        .then((response) => {
          this.moneyAccounts = response.result || [];
        })
        .catch((e) => {
          console.log("money_accounts.filter error", e);
          this.moneyAccounts = [];
        });
    },

    async generatePayments() {
      this.envios_creados = 0;
      this.envios_no_validos = 0;
      this.loading_create = true;

      for (let index = 0; index < this.paymentOrdersList.length; index++) {
        if (
          this.paymentOrdersList[index].msg === "" &&
          !this.paymentOrdersList[index].status_create &&
          this.paymentOrdersList[index].status === 0
        ) {
          this.paymentOrdersList[index].loading = true;

          const result = await this.createItem(this.paymentOrdersList[index]);

          this.paymentOrdersList[index].loading = false;
          this.paymentOrdersList[index].status = 1;
          this.paymentOrdersList[index].status_create = result.status;
          this.paymentOrdersList[index].msg = result.status ? "" : (result.msg || "Error al crear el pago");

          if (result.status) {
            this.envios_creados++;
          }
        }
      }

      this.loading_create = false;

      const total = this.paymentOrdersList.length;
      const errores = total - this.envios_creados;

      if (errores === 0) {
        this.$toast.success(
          "Se crearon " + this.envios_creados + " pago(s) correctamente.",
          "Ok"
        );
        this.$emit("loadList");
        this.closeDialog();
      } else {
        this.$toast.warning(
          "Se crearon " + this.envios_creados + " pago(s), pero " + errores + " no se pudieron crear.",
          "Precaución"
        );
        this.$emit("loadList");
      }
    },

    async createItem(item) {
      const response = await paymentOrderService.get(item.id);
      if (!response.status) {
        return response;
      }
      const fullItem = response.result;

      const spents = JSON.parse(JSON.stringify(fullItem.spents || [])).map(spent => ({
        ...spent,
        id: 0,
      }));

      const tributes = JSON.parse(JSON.stringify(fullItem.tributes || [])).map(tribute => ({
        ...tribute,
        id: 0,
      }));

      const data = {
        spents_arr: spents,
        supplier: item.supplier_id,
        receiver_id: item.receiver_id,
        payment_method: this.massivePaymentItem.payment_method,
        cbte_fch: this.massivePaymentItem.cbte_fch,
        dolar_cotiz: this.massivePaymentItem.dolar_cotiz,
        // lo que voy a transferir (importe sin retenciones)
        amount: item.amount,
        // lo que voy a imputar (importe con retenciones)
        imp_total: item.imp_total,
        fch_payment_efective: this.massivePaymentItem.cbte_fch,
        tributes_arr: tributes,
        cheque: this.massivePaymentItem.cheque,
        spent_payment_methods_arr: [
          {
            id: 0,
            payment_method: this.massivePaymentItem.payment_method,
            money_account: this.massivePaymentItem.money_account,
            fch_payment_efective: this.massivePaymentItem.cbte_fch,
            amount: item.amount,
            cheque: null,
            reference: null,
          },
        ],
        observation: this.massivePaymentItem.observation,
        payment_order_id: item.id,
        send_payment_email: this.massivePaymentItem.send_payment_email,
      };

      return paymentSpentService.create(data);
    },
  }
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none !important;
}

.dialog-footer {
  flex-shrink: 0;
  background: white;
}

.text-green {
  color: #4caf50;
}

.text-red {
  color: #f44336;
}
</style>
